import React, { useContext, useEffect, useRef } from 'react';
import { MetadataContext, ModuleBase } from '@/components';
import { ModuleBaseModel, ModuleBasePropsModel } from '@/types';
import { loadScriptsParallel, parseCMSScripts } from '@/utils';
import Cookies from 'js-cookie';
import { useRouter } from 'next/router';

export type ScriptModuleModel = ModuleBaseModel<
  {
    script?: string;
    isGate?: boolean;
  } & ModuleBasePropsModel
>;

const ScriptModule = (data: ScriptModuleModel) => {
  const { script } = data.props;
  const { pageId } = useContext(MetadataContext);
  const router = useRouter();

  const divElement = useRef<HTMLDivElement>(null);

  useEffect(() => {
    let scriptElement: HTMLScriptElement | null = null;

    const parseScripts = async () => {
      if (script) {
        const parsedScripts = parseCMSScripts(script);
        if (parsedScripts) {
          await loadScriptsParallel(parsedScripts.scripts);

          if (parsedScripts.vanillaScripts && divElement.current) {
            scriptElement = document.createElement('script');
            scriptElement.type = 'text/javascript';
            scriptElement.text = parsedScripts.vanillaScripts.innerHTML; // <-- your API code here
            divElement.current.appendChild(scriptElement);
          }
        }
      }
    };

    parseScripts();
    return () => {
      scriptElement?.remove();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const onPostMessage = async (event: MessageEvent) => {
      const { type, eventName } = event.data;

      // Handle messages from Hubspot forms
      if (type === 'hsFormCallback' && eventName === 'onFormSubmitted') {
        const COOKIE_NAME = 'CompletedGateCheckOnPageIds';

        const pageIds = (Cookies.get(COOKIE_NAME) || '').split(',').filter((id) => id !== '');
        if (pageId && !pageIds.includes(pageId + '')) {
          pageIds.push(pageId + '');
        }

        Cookies.set(COOKIE_NAME, pageIds.join(','), {
          secure: true,
          sameSite: 'lax',
          path: '/',
          maxAge: undefined,
        });

        setTimeout(() => {
          router.reload();
        }, 100);
      }
    };

    window.addEventListener('message', onPostMessage);
    return () => window.removeEventListener('message', onPostMessage);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pageId]);

  return (
    <ModuleBase data={data} className="container">
      <div ref={divElement}></div>
    </ModuleBase>
  );
};

export default ScriptModule;
